import React, { useState } from "react";
import { Button, PageHeader } from "antd";
import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";

import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import MemberDiscontinueEntry from "../../components/member/MemberDiscontinueEntry";

const MemberDiscontinue = () => {
  const params = useParams();
 
 

  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Member Discontinue"
          subTitle=""
          extra={[
            <Link to={`/member-continue`} key="reg_list">
              <Button key="1" shape='round' className='custom-button-white'> List</Button>
            </Link>
          ]}
        ></PageHeader>

        <MemberDiscontinueEntry />
      </div>
    </div>
  );
};

export default MemberDiscontinue;
